const PropTypes = require('prop-types');
const React = require('react');
const DisableableButton = require('components/shared/disableable_button.jsx');
const StreetAddressFormatHint = require(
  'components/bundled_checkout/street_address_format_hint.jsx'
);
const classNames = require('classnames');

class AddressFields extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: props.name || '',
      streetAddress: props.streetAddress || '',
      extendedAddress: props.extendedAddress || '',
      locality: props.locality || '',
      region: props.region || '',
      postalCode: props.postalCode || '',
      countryCode: props.countryCode || '',
      phone: props.phone || '',
      streetAddressForHint: '',
    };
  }

  countrySelected(selectedOption) {
    const countryCode = selectedOption ? selectedOption.value : '';
    const region = '';
    this.setState({
      countryCode,
      region,
    });
  }

  regionSelected(regionInput) {
    const region = regionInput ? regionInput.value : '';
    this.setState({
      region,
    });
  }

  regionsForSelectedCountryCode() {
    const selectedCountry = this.props.countriesForSelect.find((country) =>
      country.country_code === this.state.countryCode
    );

    if (selectedCountry && this.hasRegions(selectedCountry)) {
      return this.regionsForSelectWithBlank(selectedCountry.subregions.slice(0));
    }
    return [];
  }

  regionsForSelectWithBlank(regions) {
    return [{ code: '', name: '' }].concat(regions);
  }

  hasRegions(country) {
    return (country.subregions.length > 0);
  }

  noRegionsToSelect() {
    return (this.regionsForSelectedCountryCode().length === 0);
  }

  regionsTextInput() {
    return (
      <input
        type="text"
        className="wide required nochosen"
        data-autofill-address="region"
        name={this.props.nameForInput('region')}
        value={this.state.region}
        onChange={(event) => this.regionSelected(event.target)}
        data-update-checkout-totals
      />
    );
  }

  regionOptionsForSelect() {
    return (
      this.regionsForSelectedCountryCode().map((region) =>
        <option
          key={region.code}
          value={region.code}
        >
          {region.name}
        </option>
      )
    );
  }

  regionsField() {
    if (this.noRegionsToSelect()) { return this.regionsTextInput(); }

    return (
      <select
        autoComplete="region"
        className="required"
        data-autofill-address="region"
        name={this.props.nameForInput('region')}
        value={this.state.region}
        onChange={(event) => this.regionSelected(event.target)}
        data-update-checkout-totals
      >
        {this.regionOptionsForSelect()}
      </select>
    );
  }

  countryOptionsForSelect() {
    return (
      this.props.countriesForSelect.map((country) =>
        <option
          key={country.country_code}
          value={country.country_code}
        >
          {country.name}
        </option>
      )
    );
  }

  addressParams() {
    return (
      {
        name: this.state.name,
        streetAddress: this.state.streetAddress,
        extendedAddress: this.state.extendedAddress,
        locality: this.state.locality,
        region: this.state.region,
        postalCode: this.state.postalCode,
        countryCode: this.state.countryCode,
        phone: this.state.phone,
      }
    );
  }

  phoneInput() {
    if (!this.props.includePhoneInput) { return null; }

    return (
      <dl className="label-pairs g-col-6 g-col-mobile-12">
        <dt>
          <label>{I18n.t('js.addresses.addressForm.phone')}</label>
        </dt>
        <dd>
          <input
            name={this.props.nameForInput('phone')}
            placeholder={I18n.t('js.addresses.addressForm.placeholder.phone')}
            className={classNames('wide', { 'required': this.props.phoneInputRequired })}
            autoComplete="tel"
            type="text"
            value={this.state.phone}
            onChange={(event) => this.setState({ phone: event.target.value })}
          />
        </dd>
      </dl>
    );
  }

  hasFormActions() {
    return !!(this.props.includeSaveButton || this.props.children);
  }

  formActions() {
    if (!this.hasFormActions()) { return null; }

    return (
      <div className="address-form__actions">
        {this.saveButton()}
        {this.props.children}
      </div>
    );
  }

  saveButton() {
    if (!this.props.includeSaveButton) { return null; }

    return (
      <div className="address-form__actions__primary">
        <DisableableButton
          id="address_fields_save_button"
          disabledText={I18n.t('js.addresses.addressForm.saving')}
          enabledText={this.props.saveButtonText}
          disabled={!this.props.enabledSaveButton}
          buttonClasses="button button--green"
          handleClick={() => this.props.handleSaveClick(this.addressParams())}
        />
      </div>
    );
  }

  nameInput() {
    if (!this.props.includeNameInput) { return null; }
    return (
      <div>
        <dt>
          <label>
            {I18n.t('js.addresses.addressForm.name')}
          </label>
        </dt>
        <dd>
          <input
            name={this.props.nameForInput('name')}
            placeholder={I18n.t('js.addresses.addressForm.placeholder.name')}
            autoComplete="name"
            className="wide required"
            type="text"
            value={this.state.name}
            onChange={(event) => this.setState({ name: event.target.value })}
          />
        </dd>
      </div>
    );
  }

  render() {
    return (
      <div>
        <dl className="label-pairs">
          {this.nameInput()}
          <dt>
            <label data-address-title >
              {this.props.addressTitle}
            </label>
          </dt>
          <dd>
            <div>
              <input
                type="text"
                name={this.props.nameForInput('street_address')}
                placeholder={I18n.t('js.addresses.addressForm.placeholder.streetAddress')}
                value={this.state.streetAddress}
                className="wide required"
                autoComplete="street-address"
                onBlur={(event) => this.setState({ streetAddressForHint: event.target.value })}
                onChange={(event) => this.setState({ streetAddress: event.target.value })}
              />
              <StreetAddressFormatHint
                streetAddress={this.state.streetAddressForHint}
              />
            </div>
          </dd>
          <dd>
            <input
              name={this.props.nameForInput('extended_address')}
              placeholder={I18n.t('js.addresses.addressForm.placeholder.extendedAddress')}
              className="wide"
              autoComplete="street-address-2"
              type="text"
              value={this.state.extendedAddress}
              onChange={(event) => this.setState({ extendedAddress: event.target.value })}
            />
          </dd>
        </dl>
        <div className="g-container">
          <dl className="label-pairs g-col-6 g-col-mobile-12">
            <dt>
              <label>{I18n.t('js.addresses.addressForm.city')}</label>
            </dt>
            <dd>
              <input
                name={this.props.nameForInput('locality')}
                placeholder={I18n.t('js.addresses.addressForm.placeholder.city')}
                className="wide required"
                autoComplete="locality"
                type="text"
                value={this.state.locality}
                onChange={(event) => this.setState({ locality: event.target.value })}
              />
            </dd>
          </dl>
          <dl className="label-pairs g-col-6 g-col-mobile-12">
            <dt>
              <label>{I18n.t('js.addresses.addressForm.state')}</label>
            </dt>
            <dd>
              <div className="styled-dropdown mb-0">
                {this.regionsField()}
              </div>
            </dd>
          </dl>
        </div>
        <div className="g-container">
          <dl className="label-pairs g-col-6 g-col-mobile-12">
            <dt>
              <label>{I18n.t('js.addresses.addressForm.zip_code')}</label>
            </dt>
            <dd>
              <input
                name={this.props.nameForInput('postal_code')}
                placeholder={I18n.t('js.addresses.addressForm.placeholder.zip_code')}
                className="wide required"
                autoComplete="postal-code"
                type="text"
                value={this.state.postalCode}
                onChange={(event) => this.setState({ postalCode: event.target.value })}
              />
            </dd>
          </dl>
          <dl className="label-pairs g-col-6 g-col-mobile-12">
            <dt>
              <label>{I18n.t('js.addresses.addressForm.country')}</label>
            </dt>
            <dd>
              <div className="styled-dropdown mb-0">
                <select
                  name={this.props.nameForInput('country_code')}
                  className="required"
                  type="text"
                  autoComplete="country-code"
                  value={this.state.countryCode}
                  onChange={(event) => this.countrySelected(event.target)}
                  data-update-checkout-totals
                >
                  {this.countryOptionsForSelect()}
                </select>
              </div>
            </dd>
          </dl>
        </div>
        {this.phoneInput()}
        {this.formActions()}
      </div>
    );
  }
}

AddressFields.propTypes = {
  name: PropTypes.string,
  streetAddress: PropTypes.string,
  extendedAddress: PropTypes.string,
  locality: PropTypes.string,
  region: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string,
  phone: PropTypes.string,
  addressTitle: PropTypes.string.isRequired,
  countriesForSelect: PropTypes.array.isRequired,
  nameForInput: PropTypes.func.isRequired,
  children: PropTypes.element,
  includePhoneInput: PropTypes.bool.isRequired,
  phoneInputRequired: PropTypes.bool.isRequired,
  includeNameInput: PropTypes.bool.isRequired,
  includeSaveButton: PropTypes.bool.isRequired,
  saveButtonText: PropTypes.string,
  enabledSaveButton: PropTypes.bool,
  handleSaveClick: PropTypes.func,
};

AddressFields.defaultProps = {
  phoneInputRequired: true,
};

module.exports = AddressFields;



// WEBPACK FOOTER //
// ./javascripts/components/addresses/address_fields.jsx